import React from "react";
import Cart from "./Cart/Cart";
import Product from "./Product/Product";

export default function Home({ show }) {
  return (
    <>
      <main className="py-16">{show ? <Product /> : <Cart />}</main>
    </>
  );
}
